import { type HTMLAttributes } from 'react'
import styles from './Spinner.module.css'

interface SpinnerProps extends HTMLAttributes<HTMLDivElement> {
  size?: string
  center?: boolean
}

export default function Spinner({
  size = 'lg',
  center = true,
  ...htmlprops
}: SpinnerProps) {
  return (
    <div
      className={[styles.wrapper, styles[size], center ? 'center' : ''].join(
        ' '
      )}
      {...htmlprops}
    >
      <div className={[styles.spinner].join(' ')} />
    </div>
  )
}
